document.addEventListener("DOMContentLoaded", function () {
  const carousel = document.querySelector(".testimonial-carousel");
  const parentContainer = carousel?.parentElement;

  if (!carousel || !parentContainer) return;

  if (carousel.getAttribute('mobile-transition') !== 'native') {
    carousel.setAttribute('allow-swipe', 'true');
  }

  const testimonials = carousel.querySelectorAll(".testimonial-item");
  const pageDotsContainer = parentContainer.querySelector(".page-dots");
  const thumbnailScrollerContainer = parentContainer.querySelector(".testimonial-list__thumbnail-scroller");

  const pageDots = pageDotsContainer ? pageDotsContainer.querySelectorAll(".tap-area") : [];
  const thumbnails = thumbnailScrollerContainer ? thumbnailScrollerContainer.querySelectorAll(".testimonial-list__thumbnail") : [];

  testimonials.forEach((testimonial, index) => {
    const textContent = testimonial.querySelector(".prose p span")?.textContent.trim();
    const hasImage = testimonial.querySelector("img")?.src;

    if (!textContent && !hasImage) {
      testimonial.remove();
      if (pageDots[index]) pageDots[index].remove();
      if (thumbnails[index]) thumbnails[index].remove();
    }
  });
});

// Keep collection-card feedback tied to the actual Quick Add lifecycle.
// Prestige already emits dialog:after-show after the product response is rendered.
document.addEventListener('click', (event) => {
  const trigger = event.target.closest?.('button[aria-controls]');
  if (!trigger) return;

  const modal = document.getElementById(trigger.getAttribute('aria-controls'));
  if (modal?.tagName !== 'QUICK-BUY-MODAL') return;

  if (trigger.getAttribute('aria-busy') === 'true') {
    event.preventDefault();
    event.stopImmediatePropagation();
    return;
  }

  trigger.setAttribute('aria-busy', 'true');

  const finish = () => {
    trigger.removeAttribute('aria-busy');
    modal.removeEventListener('dialog:after-show', finish);
    modal.removeEventListener('dialog:after-hide', finish);
    window.removeEventListener('unhandledrejection', finish);
    window.removeEventListener('error', finish);
  };

  modal.addEventListener('dialog:after-show', finish, { once: true });
  modal.addEventListener('dialog:after-hide', finish, { once: true });
  window.addEventListener('unhandledrejection', finish, { once: true });
  window.addEventListener('error', finish, { once: true });
}, true);

// Native cart forms navigate to checkout. Keep the customer informed during
// that real navigation and reject duplicate submissions while it is pending.
document.addEventListener('submit', (event) => {
  const submitter = event.submitter;
  if (!(submitter instanceof HTMLButtonElement) || submitter.name !== 'checkout') return;

  if (submitter.getAttribute('aria-busy') === 'true') {
    event.preventDefault();
    return;
  }

  if (!event.defaultPrevented) submitter.setAttribute('aria-busy', 'true');
});


document.addEventListener('DOMContentLoaded', (event) => {
    const weekdays = ["duminică", "luni", "marți", "miercuri", "joi", "vineri", "sâmbătă"];
    const months = ["ian", "feb", "mar", "apr", "mai", "iun", "iul", "aug", "sep", "oct", "noi", "dec"];

    const holidays = [
        "01-01", "02-01", "06-01", "07-01", "24-01", "18-04", "20-04", "21-04", 
        "01-05", "01-06", "08-06", "09-06", "15-08", "30-11", "01-12", "25-12", "26-12"
    ];

    function isHoliday(date) {
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        // Corecție: Folosește formatul ZZ-LL pentru a se potrivi cu array-ul holidays
        return holidays.includes(`${day}-${month}`); 
    }

    function getNextBusinessDay(date) {
        date.setDate(date.getDate() + 1);
        while (date.getDay() === 0 || date.getDay() === 6 || isHoliday(date)) {
            date.setDate(date.getDate() + 1);
        }
        return date;
    }
    
    function updateDeliveryDate() {
        const now = new Date();
        let deliveryDate = new Date();
        const currentHour = now.getHours();

        switch (now.getDay()) {
            case 1:
                deliveryDate.setDate(now.getDate() + (currentHour >= 13 ? 2 : 1));
                break;
            case 2:
                deliveryDate.setDate(now.getDate() + (currentHour >= 13 ? 2 : 1));
                break;
            case 3:
                deliveryDate.setDate(now.getDate() + (currentHour >= 13 ? 2 : 1));
                break;
            case 4:
                deliveryDate.setDate(now.getDate() + (currentHour >= 13 ? 4 : 1));
                break;
            case 5:
                deliveryDate.setDate(now.getDate() + 4);
                break;
            case 6:
            case 0:
                deliveryDate.setDate(now.getDate() + (now.getDay() === 6 ? 3 : 2));
                break;
        }

        while (isHoliday(deliveryDate) || deliveryDate.getDay() === 0 || deliveryDate.getDay() === 6) {
            deliveryDate = getNextBusinessDay(deliveryDate);
        }

        const weekday = weekdays[deliveryDate.getDay()];
        const date = deliveryDate.getDate();
        const month = months[deliveryDate.getMonth()];

        const weekDayElement = document.getElementById("ProductDeliveryWeekDay");
        if (weekDayElement) {
            weekDayElement.textContent = weekday;
        }
        const deliveryDateElement = document.getElementById("ProductDeliveryDate");
        if (deliveryDateElement) {
            deliveryDateElement.textContent = `${date} ${month}`;
        }
    }
    
    // Update delivery date on page load
    updateDeliveryDate();

    // Listen for Shopify's custom event when variant changes
    document.addEventListener('variant:change', function(evt) {
        updateDeliveryDate();
    });
});
